import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {AppComponent} from './app.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {IndexComponent} from './index/index.component';
import {LoginComponent} from './login/login.component';
import {GuideComponent} from './guide/guide.component';
import {DownComponent} from './down/down.component';

const roters = [
  {path: '', component: IndexComponent},
  {path: 'guide', component: GuideComponent},
  {path: 'login/:id', component: LoginComponent},
  {path: 'down', component: DownComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    IndexComponent,
    LoginComponent,
    GuideComponent,
    DownComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(roters)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
